import React from 'react';

const EncountersVolumeToolbar = () => {
  return (
    <div className="flex items-center justify-between w-full h-[72px] bg-teal-050 px-4 py-3.5 border-b border-teal-400">
      <div className="flex items-center w-full">
        <div className="w-full flex flex-col justify-center">
          <div className="justify-start text-primary text-xl font-bold font-['Inter'] leading-normal">
            Analyze Volume
          </div>
          <div className="justify-start text-secondary text-xs font-normal font-['Inter'] leading-none">
            Compare volumes for...
          </div>
        </div>
      </div>
    </div>
  );
};

export default EncountersVolumeToolbar;
